// extracted by mini-css-extract-plugin
export default {"common":"Customer_common__99UtL","content":"Customer_content__Mg55X","h1":"Customer_h1__u9Ut7"};